<template>
  <div :class="`waarde-tips-card`">
  <h4  class="icon" :class=tipdata.waarde ><strong>{{tipdata.waarde}}</strong> bij {{tipdata.method}}</h4><p>{{tipdata.beschrijving}}</p><p v-if="!tipdata.tips">Geen tips gevonden bij deze democratische waarde</p>
  <div class="tiprow" v-for="(tipje,index) in tipdata.tips"  :key="index">
      <div class="tiprow__tiptext">
       <span class="red">Tip: </span><span v-html="tipje.value"></span>
      </div>
      <div class="tiprow__checktip">
        <input type="checkbox" :value="tipje.id" :id="tipje.checkboxvalue" name="checktip" :checked="tipje.checked" v-on:change="changeTipChecked">
        <label :for="tipje.checkboxvalue" :id="tipje.id">in PDF</label>
      </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "TipCard",

  props: {
    tipdata: Array,
    hiddenTips: Array,
  },

  computed: {
  },

  methods: {
    changeTipChecked: function(event) {
      // use these variables
      // which tip is (un)checked?
      let tipid = event.target.value
      let isChecked = event.target.checked

      if (isChecked) {
        this.hiddenTips.splice(this.hiddenTips.indexOf(tipid), 1);
      }
      if (!isChecked) {
        this.hiddenTips.push(tipid);
      }
      const parsed = JSON.stringify(this.hiddenTips);
      localStorage.setItem('hiddenTips', parsed);

    },
    
    cleanClass(j) {
      return j.replace(/[^a-z]/gi, '').toLowerCase();
    }

  },

  mounted() {

  }
};
</script>

